/** Every sprite by name, with its frames (docs/spec/04 §3). */

import { BLINK, RUN_LEFT, RUN_RIGHT, STAND, TAP } from './digby';
import {
  amoebaFrames,
  butterflyFrames,
  coverFrames,
  diamondFrames,
  expandingWallFrame,
  explosionFrames,
  fireflyFrames,
  magicWallFrames,
  slimeFrames,
} from './generated';
import { BOULDER, BRICK, CLOCK_A, CLOCK_B, DIRT, DOOR, KEY, LOCKED_DOOR, OPEN_DOOR, SPACE, STEEL } from './tiles';
import type { Frame } from './types';

/** `key0`..`key2`: drawn in a key colour instead of the cave's (palette.ts KEY_COLOURS). */
export type SpritePalette = 'cave' | 'key0' | 'key1' | 'key2';

export interface SpriteDef {
  readonly frames: readonly Frame[];
  readonly palette: SpritePalette;
}

function def(frames: readonly Frame[], palette: SpritePalette = 'cave'): SpriteDef {
  return { frames, palette };
}

export const SPRITES = {
  space: def([SPACE]),
  dirt: def([DIRT]),
  brick: def([BRICK]),
  steel: def([STEEL]),
  magicWall: def(magicWallFrames()),
  boulder: def([BOULDER]),
  diamond: def(diamondFrames()),
  door: def([DOOR]),
  digbyStand: def([STAND]),
  digbyBlink: def([BLINK]),
  digbyTap: def([TAP]),
  digbyRight: def(RUN_RIGHT),
  digbyLeft: def(RUN_LEFT),
  firefly: def(fireflyFrames()),
  butterfly: def(butterflyFrames()),
  amoeba: def(amoebaFrames()),
  explosion: def(explosionFrames()),
  cover: def(coverFrames()),
  expandingWall: def([expandingWallFrame()]),
  slime: def(slimeFrames()),
  clock: def([CLOCK_A, CLOCK_B]),
  key0: def([KEY], 'key0'),
  key1: def([KEY], 'key1'),
  key2: def([KEY], 'key2'),
  door0: def([LOCKED_DOOR], 'key0'),
  door1: def([LOCKED_DOOR], 'key1'),
  door2: def([LOCKED_DOOR], 'key2'),
  doorOpening: def([OPEN_DOOR]),
} as const satisfies Record<string, SpriteDef>;

export type SpriteName = keyof typeof SPRITES;

export const SPRITE_NAMES = Object.keys(SPRITES) as SpriteName[];

export function frameCount(name: SpriteName): number {
  return SPRITES[name].frames.length;
}
